<script>
  export default {
    props: {
      total: {
        type: Number,
        default: 50,
      },
      pageSize: {
        type: Number,
        default: 10,
      },
      pagerCount: {
        type: Number,
        default: 5,
      },
    },
    methods: {
      onCurrentChange(page) {
        this.$emit('change', page)
      }
    },
  }
</script>
<template>
  <el-pagination class="isStyleBase" layout="prev, pager, next" :total="total" :page-size="pageSize"
                 :pager-count="pagerCount" :current-page="+$route.query.page || 1"
                 @current-change="onCurrentChange"></el-pagination>
</template>
<style lang="scss">

</style>
